import React from "react";
import { Col, Row, Table, Typography } from "antd";
import type { TableProps } from "antd";
import CopyIcon from "./../../../assets/svgs/CopyIcon.svg";
import CopyToClipboard from "react-copy-to-clipboard";
import { formatDate } from "../../../helpers/date";
import "./index.css";
import useMultiNotification from "../../../hooks/useNotification";

const PendingVouchersTable: React.FC<PendingDiscountVouchersTableProp> = ({
  vouchers,
}) => {
  const { openNotification, contextHolder } = useMultiNotification();

  const columns: TableProps<PendingDiscountVoucherProp>["columns"] = [
    {
      title: "Voucher Number",
      render: (row) => (
        <Typography
          style={{ display: "flex", alignContent: "center", gap: "10px" }}
        >
          {row.voucherNumber}
          <CopyToClipboard
            text={row.voucherNumber || ""}
            onCopy={() => {
              openNotification(
                "success",
                "Success",
                `Voucher ${row.voucherNumber} Copied to Clipboard`
              );
            }}
          >
            <img
              onClick={(e) => {
                e.preventDefault();
              }}
              src={CopyIcon}
              className="cursor-pointer "
            />
          </CopyToClipboard>
        </Typography>
      ),
    },
    {
      title: "Amount",
      dataIndex: "discountAmount",
      key: "discountAmount",
    },
    {
      title: "Type",
      dataIndex: "voucherType",
      key: "voucherType",
      render: (text) => (
        <span>{text === "ONCE" ? "One Time" : "Every Month"}</span>
      ),
    },
    {
      title: "Created",
      dataIndex: "dateCreated",
      key: "dateCreated",
      render: (text) => <span>{formatDate(new Date(text))}</span>,
    },
  ];

  return (
    <>
      {contextHolder}

      <div className="netwala-users-table-container">
        <Row>
          <Col span={24}>
            <Typography className="netwala-user-tables-heading">
              Unused Vouchers
            </Typography>
            <Table
              className="netwala-users-table striped-table"
              columns={columns}
              dataSource={vouchers}
              pagination={false}
              scroll={{ x: "max-content" }}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};
export default PendingVouchersTable;
